module.exports = __webpack_public_path__ + "img/andrews.6afc59a5.png";